/**
 * 埋点事件配置
 * 维护所有上报的eventId和相关信息
 */

export const TRACK_EVENTS = {
  // 网站相关事件
  NAV_DAU: {
    eventId: 'nav_dau',
    description: '导航网站日活跃用户',
    category: 'user_activity'
  },
  
  NAV_WEBSITE_CLICK: {
    eventId: 'nav_website_click',
    description: '网站点击跳转',
    category: 'website_interaction'
  },

  NAV_PAGE_VIEW: {
    eventId: 'nav_page_view',
    description: '页面访问',
    category: 'navigation'
  },

  NAV_USER_ACTION: {
    eventId: 'nav_user_action',
    description: '用户操作',
    category: 'user_interaction'
  },

  NAV_ERROR: {
    eventId: 'nav_error',
    description: '系统错误',
    category: 'system'
  },

  // 搜索相关事件
  NAV_SEARCH: {
    eventId: 'nav_search',
    description: '搜索操作',
    category: 'search'
  },

  NAV_SEARCH_RESULT_CLICK: {
    eventId: 'nav_search_result_click',
    description: '搜索结果点击',
    category: 'search'
  },

  // 设置相关事件
  NAV_SETTINGS_CHANGE: {
    eventId: 'nav_settings_change',
    description: '设置变更',
    category: 'settings'
  },

  NAV_THEME_CHANGE: {
    eventId: 'nav_theme_change',
    description: '主题切换',
    category: 'settings'
  },

  NAV_WALLPAPER_CHANGE: {
    eventId: 'nav_wallpaper_change',
    description: '壁纸切换',
    category: 'settings'
  },

  // 分类相关事件
  NAV_CATEGORY_CLICK: {
    eventId: 'nav_category_click',
    description: '分类点击',
    category: 'navigation'
  },

  NAV_CATEGORY_ADD: {
    eventId: 'nav_category_add',
    description: '添加分类',
    category: 'management'
  },

  NAV_CATEGORY_EDIT: {
    eventId: 'nav_category_edit',
    description: '编辑分类',
    category: 'management'
  },

  NAV_CATEGORY_DELETE: {
    eventId: 'nav_category_delete',
    description: '删除分类',
    category: 'management'
  },

  // 网站管理事件
  NAV_WEBSITE_ADD: {
    eventId: 'nav_website_add',
    description: '添加网站',
    category: 'management'
  },

  NAV_WEBSITE_EDIT: {
    eventId: 'nav_website_edit',
    description: '编辑网站',
    category: 'management'
  },

  NAV_WEBSITE_DELETE: {
    eventId: 'nav_website_delete',
    description: '删除网站',
    category: 'management'
  },

  NAV_WEBSITE_DRAG: {
    eventId: 'nav_website_drag',
    description: '网站拖拽排序',
    category: 'management'
  },

  // 用户相关事件
  NAV_USER_LOGIN: {
    eventId: 'nav_user_login',
    description: '用户登录',
    category: 'user_activity'
  },

  NAV_USER_LOGOUT: {
    eventId: 'nav_user_logout',
    description: '用户登出',
    category: 'user_activity'
  },

  NAV_USER_REGISTER: {
    eventId: 'nav_user_register',
    description: '用户注册',
    category: 'user_activity'
  },

  // 同步相关事件
  NAV_SYNC_START: {
    eventId: 'nav_sync_start',
    description: '开始同步',
    category: 'sync'
  },

  NAV_SYNC_SUCCESS: {
    eventId: 'nav_sync_success',
    description: '同步成功',
    category: 'sync'
  },

  NAV_SYNC_FAIL: {
    eventId: 'nav_sync_fail',
    description: '同步失败',
    category: 'sync'
  },

  // 性能相关事件
  NAV_PERFORMANCE: {
    eventId: 'nav_performance',
    description: '性能监控',
    category: 'performance'
  },

  NAV_LOAD_TIME: {
    eventId: 'nav_load_time',
    description: '页面加载时间',
    category: 'performance'
  },

  // 扩展相关事件
  EXTENSION_VERSION_LOADED: {
    eventId: 'extension_version_loaded',
    description: '扩展版本加载',
    category: 'extension'
  },

  EXTENSION_INSTALL: {
    eventId: 'extension_install',
    description: '扩展安装',
    category: 'extension'
  },

  EXTENSION_UPDATE: {
    eventId: 'extension_update',
    description: '扩展更新',
    category: 'extension'
  }
};

/**
 * 获取事件配置
 * @param {string} eventKey 事件键名
 * @returns {Object} 事件配置
 */
export const getEventConfig = (eventKey) => {
  return TRACK_EVENTS[eventKey] || null;
};

/**
 * 获取所有事件配置
 * @returns {Object} 所有事件配置
 */
export const getAllEventConfigs = () => {
  return TRACK_EVENTS;
};

/**
 * 按分类获取事件配置
 * @param {string} category 分类名称
 * @returns {Object} 该分类下的事件配置
 */
export const getEventsByCategory = (category) => {
  const events = {};
  Object.keys(TRACK_EVENTS).forEach(key => {
    if (TRACK_EVENTS[key].category === category) {
      events[key] = TRACK_EVENTS[key];
    }
  });
  return events;
};

/**
 * 验证事件ID是否有效
 * @param {string} eventId 事件ID
 * @returns {boolean} 是否有效
 */
export const isValidEventId = (eventId) => {
  return Object.values(TRACK_EVENTS).some(event => event.eventId === eventId);
};

/**
 * 获取事件ID列表
 * @returns {Array} 事件ID列表
 */
export const getEventIdList = () => {
  return Object.values(TRACK_EVENTS).map(event => event.eventId);
};

export default TRACK_EVENTS; 